/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_MacrosInputs */

const en_for_whom_tag_macros = /** @type {(inputs: For_Whom_Tag_MacrosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macros`)
};

const pl_for_whom_tag_macros = /** @type {(inputs: For_Whom_Tag_MacrosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makro`)
};

/**
* | output |
* | --- |
* | "Macros" |
*
* @param {For_Whom_Tag_MacrosInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_macros = /** @type {((inputs?: For_Whom_Tag_MacrosInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_MacrosInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_macros(inputs)
	return en_for_whom_tag_macros(inputs)
});